import React from 'react';
import moment from 'moment';
import { Checkbox, TableCell, TableRow, Tooltip, Box, Button } from '@mui/material';
import RestoreIcon from '@mui/icons-material/Restore';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatterCurrency } from '../../../utils';
import LessMoreComp from '../../../shared_elements/components/CustomLessMoreComp';
import { AttachFile } from '@mui/icons-material';
import { PermissionWrapper } from '../../../wrappers';
import UploadingIcon from '../../../shared_elements/components/UploadingIcon';
import { trackActivity } from '../../../utils/mixpanel';
import AuditPopover from '../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { dateMonthYearDateFormat } from '../../../constants';

const OpeningBalanceList = ({uploadedFileData,slug,uploadFileProgressData, viewFileStatus, toggleBulkOps, viewRevisonHistory, item, onEdit, onDelete, onView, viewFile, bulk, statusChange, leaseBasicDetails }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Reserve Rates Listing`, page_type: page_type, })
  }
  
  return (
    <TableRow >
      <TableCell className="table-actions-list">
        <Box className="icon-container" style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['D'] }}>
            {leaseBasicDetails?.is_reserve_rate === 0 ?
              <Checkbox color='primary' size='small' checked={bulk?.ids.find(items => items?.id === item?.id) ? true : false} onChange={(e) => toggleBulkOps(e.target.checked, 'single', item)} />
               : null}
          </PermissionWrapper>
            <AuditPopover item={item}>
              <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
            </AuditPopover>
          <Tooltip title="Revision History">
            <RestoreIcon className='revision-history' fontSize="small" color="primary" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} sx={{ cursor: "pointer" }} />
          </Tooltip>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['R'] }}>
            <Tooltip title="View">
              <VisibilityIcon fontSize="small" color="primary" onClick={() => { onView(); handleItemClicked('ViewIcon') }} sx={{ cursor: "pointer" }} />
            </Tooltip>
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['U'] }}>
            <Tooltip title="Edit">
              <EditIcon fontSize="small" color="primary" onClick={() => { onEdit(); handleItemClicked('EditIcon') }} sx={{ cursor: "pointer" }} />
            </Tooltip> 
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['D'] }}>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" color="error" onClick={() => { onDelete(); handleItemClicked('DeleteIcon') }} sx={{ cursor: "pointer" }} />
            </Tooltip> 
          </PermissionWrapper>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "reserve_rates", operationType: ['R'] }}>
            {
              item?.attachments?.length > 0 && (
                <Tooltip title="Attached File(s)">
                  <Box className="attachment-container">
                    <AttachFile fontSize="small" color="primary" onClick={() => { viewFile(); handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer" }} />
                    <Box className="attachment-count" >
                      ({item.attachments.length})
                    </Box>
                  </Box>
                </Tooltip>
              )
            }
          </PermissionWrapper>
           { (slug === item?.slug ) && <UploadingIcon viewFileStatus={() => viewFileStatus(uploadedFileData)} /> }
        </Box>
      </TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.major_assembly?.name || '--'}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.mainteance_program_id?.name|| '--'}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{`${formatterCurrency(item?.currency?.code).format(item?.asset_type === 2 && [2, 3].includes(item?.claim_event_type?.value) ? (item?.opening_balance_engine_split_details || []).reduce((total, split) => total + (Number(split?.fund_balance) || 0), 0) : (item?.amount || 0.00))}`} </TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}>{item?.fund_balance_as_of ? moment(item?.fund_balance_as_of).format(dateMonthYearDateFormat) : "--"}</TableCell>
      <TableCell sx={{cursor: 'pointer'}} onClick={() => {onView(); handleItemClicked();}}><div style={{ width: item?.remarks?.length > 50 ? "300px" : ''}}><LessMoreComp name={item?.remarks} lessMr='Remarks' /></div></TableCell>
    </TableRow>
  );
};

export default OpeningBalanceList;